import { render } from "./UserDataForm.vue?vue&type=template&id=cb350d48&scoped=true&ts=true"
import script from "./UserDataForm.vue?vue&type=script&lang=ts"
export * from "./UserDataForm.vue?vue&type=script&lang=ts"

import "./UserDataForm.vue?vue&type=style&index=0&id=cb350d48&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb350d48"]])

export default __exports__